/** Species choice is independent of physique, pigments and costume. Legacy meshes remain loadable. */
export const ATELIER_SPECIES = [
  {id:'cat',model:'tabby-st',name:'Кот',en:'Cat'},
  {id:'fox',model:'fox-st',name:'Лис',en:'Fox'},
  {id:'hare',model:'hare-st',name:'Заяц',en:'Hare'},
  {id:'wolf',model:'wolf-st',name:'Волк',en:'Wolf'},
  {id:'lynx',model:'lynx-st',name:'Рысь',en:'Lynx'},
] as const;
export const ATELIER_MODEL_IDS = ['tabby-st','ink-st','tabby-71s','fox-st','hare-st','wolf-st','lynx-st'] as const;
export function atelierBaseModel(id:string):string { return id==='wolf-st'?'fox-st':id==='lynx-st'?'tabby-st':id; }
export function atelierModelUrl(id:string):string { const base=atelierBaseModel(id);return `/models/base/${base.startsWith('tabby')||base.startsWith('ink')?'cat-':''}${base}.glb`; }
export function atelierSpecies(id:string):typeof ATELIER_SPECIES[number] { return ATELIER_SPECIES.find(s=>s.model===id)??ATELIER_SPECIES[0]; }
